import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import Clipboard from 'clipboard';

@Directive({
  selector: '[i2gClipboard]',
})
export class ClipboardDirective implements OnInit, OnDestroy {
  @Input('i2gClipboard') elt: ElementRef;

  @Output() clipboardSuccess: EventEmitter<any> = new EventEmitter();
  @Output() clipboardError: EventEmitter<any> = new EventEmitter();

  clipboard: any;

  constructor(private _elementRef: ElementRef) {}

  ngOnInit() {
    this.clipboard = new Clipboard(this._elementRef.nativeElement, {
      target: () => {
        return this.elt.nativeElement;
      },
    });
    this.clipboard.on('success', () => {
      this.clipboardSuccess.emit();
    });
    this.clipboard.on('error', () => {
      this.clipboardError.emit();
    });
  }

  ngOnDestroy() {
    if (this.clipboard) {
      this.clipboard.destroy();
    }
  }
}
